import BaseModalView from "scripts/views/baseModalView";
import templateRatingModal from "templates/ratingModal.hbs";

class RatingModalView extends BaseModalView {
  get template() {
    return templateRatingModal;
  }

  get events() {
    return {
      "click .bb-star-rating": "onClickStarRating",
    };
  }

  constructor(options) {
    super(options);

    this.ratingModel = options.ratingModel;
    this.contentModel = options.contentModel;
  }

  render() {
    this.$el.html(
      this.template({
        title: this.contentModel.get("title"),
        usersCurrentVote: this.ratingModel.get("usersCurrentVote"),
      }),
    );

    return this;
  }

  onClickStarRating(event) {
    const starRating = $(event.currentTarget).data("star-rating");

    this.trigger("rateMedia", starRating);

    return false;
  }
}

export default RatingModalView;
